import { render } from "./object-metric.vue?vue&type=template&id=b652b068"
import script from "./object-metric.vue?vue&type=script&lang=js"
export * from "./object-metric.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__